module.exports = __webpack_public_path__ + "img/BAWS_AxeBasic1_2.a3afb4e4.png";